import { Component, EventEmitter, forwardRef, HostBinding, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ErrorStateMatcher } from '@angular/material/core';
import { CluesFilterDto } from 'src/app/core/models/configuration/branchoffice/clues-filter-dto';
import { CluesService } from 'src/app/core/services/configuration/branch_office/clues.service';
import { StaticHandlers } from 'src/app/inside/patients/clinical/medical-notes/emergencies/discharge-notes/components/discharge-emergencies.utils';



@Component({
  selector: 'app-clues-autocomplete',
  templateUrl: './clues.autocomplete.component.html',
  styleUrls: ['./clues.autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CluesAutocompleteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CluesAutocompleteComponent),
      multi: true
    }
  ]
})
export class CluesAutocompleteComponent implements OnInit, ControlValueAccessor, Validator {

  StaticHandlers = StaticHandlers;

  @Input() label: string|null = null;
  @Input() placeholder: string = '';
  @Input() errorStr: string = '';
  @Input() errorNotFoundStr: string = 'La CLUES no existe en el catálogo de Establecimientos de salud.';
  @Input() maskSelection: string | null = null;
  @Input() patientId: number| null;
  @Input() required: boolean = false;
  @Input() errorStateMatcher!: ErrorStateMatcher;
  @Input() releaseDateStr: string | null = null;

  @Input() options: string[] = [];


  @Output() isLoadingChange = new EventEmitter<boolean>();
  @Output() optionChange = new EventEmitter<String>();

  private static nextId = 0;
  public inputId = `clues-${CluesAutocompleteComponent.nextId++}`;
  public resultList: String[] = [];
  public isLoading = false;
  public notFoundCoincidences = false;

  public myFormControl= new FormControl();

  /**
   *
   * @param diagMasterService
   */
  constructor( private cluesService: CluesService,
   )
  {}


  ngOnInit(): void {
    if (this.required) {
      this.myFormControl.setValidators(Validators.required);
      this.myFormControl.reset();
    }
  }



  // Event (blur)
  clearIfNotSelected()
  {
    const currentValue = this.myFormControl.value;
    const isOptionSelected = this.resultList
      .some(option => option === currentValue);
    if (!isOptionSelected) {
      this.myFormControl.setValue(null);
      this.optionChange.emit(null);
    }
  }

  // Event (input)
  onChangefilter()
  {
    this.isLoadingChange.emit(true);
    this.isLoading = true;
    let myClue =  this.myFormControl.value || ''
    const filter = {
      clue: myClue.toUpperCase(),
      releaseDateStr: this.releaseDateStr
    } as CluesFilterDto;
    this.cluesService.getCluesAutocompleteByFilter(filter)
      .then((data) => {
        this.resultList = data
        this.notFoundCoincidences = (data != null && data.length == 0) ? true : false;
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        this.isLoading = false;
        this.isLoadingChange.emit(false);
      });
  }


  onItemSelected(event: MatAutocompleteSelectedEvent)
  {
    var option: String = event.option.value;
    this.myFormControl.setValue(option);
    this.optionChange.emit(option);
  }





  // Implementación de ControlValueAccessor
  writeValue(value: any): void {
    this.myFormControl.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.myFormControl.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.myFormControl.valueChanges.subscribe(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.myFormControl.disable();
    } else {
      this.myFormControl.enable();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['required']) { this.applyRequiredValidator(); }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.myFormControl.errors;
  }
  private applyRequiredValidator(): void {
    if (this.required) {
      this.myFormControl.setValidators(Validators.required);
    } else {
      this.myFormControl.clearValidators();
    }
    this.myFormControl.updateValueAndValidity({ emitEvent: false });
  }

  setTouchedControl(value: boolean):void {
    if(value){
      this.myFormControl.markAllAsTouched();
      return;  
    }
    this.myFormControl.markAsUntouched();
  }
}
